import { useTranslation } from 'react-i18next'
import { StyleSheet, View } from 'react-native'
import { Spacing } from 'zens-storybook'
import { Suspense, useEffect } from 'react'
import { useNumberParams, useRouter } from 'zens-router'
import { AccessType } from 'zens-store'
import { useBreadcrumb } from '@dms/hook'
import { AssistantChat, LayoutHeader } from '@dms/component'
import { usePermissions } from '@dms/hook'

const styles = StyleSheet.create({
  container: {
    flex: 1,
    height: '100%'
  },
  content: {
    flex: 1,
    height: '100%',
    marginHorizontal: Spacing.L,
    marginTop: Spacing.S,
    marginBottom: Spacing.L,
  },
})

const Assistant = () => {
  const { t } = useTranslation()
  const [{ companyId }] = useNumberParams()
  const router = useRouter()
  const { hasPermission, isSysAdmin } = usePermissions(companyId)
  const isChatbotAllowed = isSysAdmin || hasPermission(AccessType.Read, 'insights')

  useEffect(() => {
    if (!isChatbotAllowed) {
      router.replace(`/companies/${companyId}`)
    }
  }, [companyId, isChatbotAllowed, router])

  if (!isChatbotAllowed) {
    return null
  }

  const breadcrumb = useBreadcrumb([
    {
      title: t('AI Data Assistant'),
    },
  ])

  return (
    <View style={styles.container}>
      <LayoutHeader title={t('AI Data Assistant')} breadcrumb={breadcrumb} />
      <View style={styles.content}>
        <Suspense fallback={<AssistantChat.Skeleton />}>
          <AssistantChat companyId={companyId} />
        </Suspense>
      </View>
    </View>
  )
}

export default Assistant
